import {grayColors} from "../../architecture/gray-colors";

export const baseColors = {
    base01: "#0ea79b", //brandTeal
    base01Contrast: "#19322f", //blackTeal
    base01Dark: "#8cd1ba", //softTeal
    base01Light: "#c3e3c7", //lightGreen

    base02: "#fcf6d5", //brandYellow
    base02Contrast: "#4c1723", //blackRed
    base02Dark: "#a4867c", //tan
    base02Light: "#eadfc3", //sepia

    base03: "#bc3554", //pink
    base03Contrast: "#fcf6d5", //brandYellow,
    base03Dark: "#b01619", //brick
    base03Light: "#ff014f", //red

    base04: "#ffd683", //peach
    base04Contrast: "#4c1723", //blackRed
    base04Dark: "#ffbe0b", //papaya
    base04Light: "#ffff00", //yellow


    base05: "#7aec37", //inchWorm
    base05Contrast: "#000000",
    base05Dark: "#135823",
    base05Light: "#d5ec37", //pear //#87ee4b

    logoBackground: "#DAEBCD",

    ...grayColors
}